import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "data-name": "Layer 1",
  viewBox: "0 0 99.518 126.653"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M99.518 38.58C94.886 22.685 68.948 5.078 51.842.465l.002-.008c-.347-.1-.69-.225-1.036-.325v.005a3.9 3.9 0 0 0-2.432.141h-.017C31.269 4.6 4.693 22.474 0 38.58c8.506 27.231 8.65 39.795.06 67.066a3.44 3.44 0 0 0 .92 2.91c13.741 10.735 31.172 18.431 48.78 18.086 17.607.345 35.037-7.351 48.78-18.086a3.44 3.44 0 0 0 .919-2.91c-8.591-27.27-8.448-39.835.059-67.066M79.6 69.987c-3.56-.88-21.636-9.288-21.599-3.426a170.6 170.6 0 0 0 .344 53.966c1.652 5.672-4.797 3.471-8.587 3.631-3.79-.16-10.24 2.041-8.588-3.63a170.5 170.5 0 0 0 .344-53.967c.037-5.862-18.038 2.546-21.599 3.426-5.581 1.043-2.021-10.284-3.087-13.423-.994-5.874 25.754-5.731 32.93-6.24 7.176.508 33.924.366 32.93 6.24-1.066 3.139 2.493 14.465-3.088 13.423" }, null, -1)
  ]))]))
}
export default { render: render }